import { textSectionObsv } from './intersectionObservers';

export default initTextIntroTransitions;

function initTextIntroTransitions() {
  [...document.querySelectorAll('.ani__enter-side')].forEach(textSection => {
    textSection.classList.add('ani__exit');
    textSectionObsv().observe(textSection);
  });
}